import { ModuleName, SubModuleConfig, SubModuleName } from "./types";

export const SUB_MODULES: SubModuleConfig = {
  [ModuleName.Map]: [
    {
      name: SubModuleName.FeatureSelector,
    },
  ],
};
